import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const List = styled.div`
  &:not(:last-child) {
    margin-bottom: 24px;
  }
`
export const Title = styled.h6`
  ${props => props.theme.typography.h6}
  color: ${props => props.theme.color.black};
  margin: 0 0 16px;
`
export const ProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  &:not(:last-child) {
    margin-bottom: 24px;
  }
`
export const Profile = styled(Link)`
  ${props => props.theme.typography.p1}
  color: ${props => props.theme.color.dimgrey};
  cursor: pointer;
  text-decoration: none;
  &:hover {
    color: ${props => props.theme.color.dodgerblue};
  }
`
